import CyberSecurity from '../apis/cyberSecurityData';

export const loadSubscriptionData = (callback) => async (dispatch, getState) => {
  //1. gettin the subscription object
  const subscriptionDataResponse = await CyberSecurity.get('/stripe-subscription', {
    headers: {
      Authorization: 'Bearer ' + getState().accessToken
    }
  })

  if (subscriptionDataResponse.data?.subscription) {
    dispatch({
      type: 'UPDATE_SUBSCRIPTION',
      payload: subscriptionDataResponse.data.subscription
    })
  }

  //getting the payment methods
  if (subscriptionDataResponse.data?.paymentMethods) {
    dispatch({
      type: 'UPDATE_PAYMENT_METHODS',
      payload: subscriptionDataResponse.data.paymentMethods
    })
  }

  //getting the default payment method
  if (subscriptionDataResponse.data?.defaultPaymentMethod) {
    dispatch({
      type: 'UPDATE_DEFAULT_PAYMENT_METHODS',
      payload: subscriptionDataResponse.data.defaultPaymentMethod
    })
  }

  //getting the invoices
  if (subscriptionDataResponse.data?.invoices) {
    dispatch({
      type: 'UPDATE_INVOICES',
      payload: subscriptionDataResponse.data.invoices
    })
  }

  if (callback) callback()
}

export const updateSubscriptionData = (subscription) => {
  return {
    type: 'UPDATE_SUBSCRIPTION',
    payload: subscription
  }
}

export const updatePaymentMethods = (methods) => {
  return {
    type: 'UPDATE_PAYMENT_METHODS',
    payload: methods
  }
}

export const updateDefaultPaymentMethods = (defaultMethodId) => {
  return {
    type: 'UPDATE_DEFAULT_PAYMENT_METHODS',
    payload: defaultMethodId
  }
}

export const updateInvoices = (invoices) => {
  return {
    type: 'UPDATE_INVOICES',
    payload: invoices
  }
}
